export default __webpack_public_path__ + "static/media/CI.c3a627c1.png";